import { apiClient } from '@/services/api';
import type { Action } from '@/types/deal';

export const actionsService = {
  /**
   * `sync` asks the server to re-read the provider first (MarketPryce Social:
   * Voltr has no webhooks). Only for a user-visible moment: the deal page
   * opening and pull-to-refresh, never the background poll.
   */
  async list(dealIds?: number[], { sync = false }: { sync?: boolean } = {}): Promise<Action[]> {
    const params = (dealIds ?? []).map((id) => `deal_ids[]=${id}`);
    if (sync && params.length > 0) params.push('sync=1');
    const query = params.length > 0 ? `?${params.join('&')}` : '';
    const { actions } = await apiClient.get<{ actions: Action[] }>(
      `/api/v1/actions${query}`,
    );
    return actions;
  },

  /**
   * Tap a step's CTA. Server completes the step in `step_completions`,
   * idempotent — re-tapping an already-completed step returns 200 with
   * current state. Steps must complete in order; out-of-order errors
   * include the active_step_key in `ApiError.details` (api client
   * extracts the Rails-style bare-string error envelope).
   */
  async advance(actionId: number, stepKey: string): Promise<Action> {
    const { action } = await apiClient.post<{ action: Action }>(
      `/api/v1/actions/${actionId}/advance`,
      { step_key: stepKey },
    );
    return action;
  },
};
